module.exports = __webpack_public_path__ + "img/propaganda.6132f51a.png";